import WebsiteBehaviors from "./index.js";
import {findDoiInElement} from "../utils/doi.js";
import Citation from "../citation.js";

import researchHosts from "../url-utils/research-hosts.json" assert {type:"json"};

class ResearchDatabase extends WebsiteBehaviors {
	identifier() {
		return "ResearchDatabase";
	}

	// @ts-expect-error TS(7006) FIXME: Parameter 'location' implicitly has an 'any' type.
	static test(location) {
		return researchHosts.includes(location.host.toLowerCase());
	}

	async generateStructuredCitation() {
		// @ts-expect-error FIXME
		const parent = await super.generateStructuredCitation();
		if (parent)
			return parent;

		// If this finds elements, it's probably the pdf.js viewer, so let's search only in the text of the PDF.
		const pdfViewerElements = document.querySelectorAll("#viewer > .page > .textLayer");
		if (pdfViewerElements.length > 0) {
			/**
			 * @ts-expect-error FIXME
			 */
			for (const element of Array.from(pdfViewerElements)) {
				const doi = findDoiInElement(element);
				if (doi)
					return await Citation.fromDOI(doi);
			}
			return null;
		}

		// Search in the entire page
		const doi = findDoiInElement(document.documentElement);
		return doi ? await Citation.fromDOI(doi) : null;
	}
}

export default ResearchDatabase;
